import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiObservationInjuriesInterface, ApiObservationsItem } from 'app/api/api.interface';
import { ApiFlightlogService } from 'app/api/api-flightlog.service';
import { NlfOrsEditorService } from 'app/ors/ors-editor/ors-editor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faDownload, faEdit, faPlus, faCheck, faTimes, faPlane } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'nlf-ors-hps-editor-flightlog',
  templateUrl: './ors-hps-editor-flightlog.component.html',
  styleUrls: ['./ors-hps-editor-flightlog.component.css']
})
export class NlfOrsHpsEditorFlightlog implements OnInit {

  @Input() involvedIndex: number;

  public modalRef;
  observation: ApiObservationsItem;

  faPlane = faPlane;
  faCheck = faCheck;
  faTimes = faTimes;
  faEdit = faEdit;
  faPlus = faPlus;
  faDownload = faDownload;

  selectedParts: string[] = [];
  svgStyle = {};
  isZoomed = false;

  flightlogData: any;
  flightlogKml: any;
  flightlogStart: any;
  flightlogUrl: string = 'https://flightlog.org/fl.html?l=2&a=34&rqtid=2&user_id=4943&trip_id=891473';
  pathCoordinates: any[] = [];

  constructor(
    private modalService: NgbModal,
    private subject: NlfOrsEditorService,
    private flightlogService: ApiFlightlogService
  ) {

    this.subject.observableObservation.subscribe(
      observation => {
        this.observation = observation;
      });
  }

  ngOnInit(): void {
  }

  update(event) {
    this.observation.involved[this.involvedIndex]['data'].flightlog = {
      data: this.flightlogData,
      path: this.pathCoordinates,
      start: this.flightlogStart
    };

    this.subject.update(this.observation);
  }

  getData() {
    this.getFlightlogData();
    this.getFlightlogKml();
  }

  getFlightlogData() {
    this.flightlogData = undefined;
    this.flightlogService.getTrip({ params: { url: this.flightlogUrl } }).subscribe(
      data => {
        this.flightlogData = data;
        try {
          this.getFlightlogStart(this.flightlogData.start_id, this.flightlogData.country_id);
        } catch (e) {
          console.error('Error fetching flightlog start:', e);
        }
        console.log(this.flightlogData);
      },
      error => {
        console.error('Error fetching flightlog data:', error);
      },
      () => {
        console.log('Flightlog data fetch complete');
      }
    );
  }

  getFlightlogKml() {
    this.pathCoordinates = [];
    this.flightlogService.getKml({ params: { url: this.flightlogUrl } }).subscribe(
      data => {
        this.flightlogKml = data['_items'][0];
        this.pathCoordinates = this.flightlogKml.features[this.flightlogKml.features.length - 1].geometry.coordinates;
        console.log(this.flightlogKml);

      },
      error => {
        console.error('Error fetching flightlog KML:', error);
      },
      () => {
        console.log('Flightlog KML fetch complete');
      }
    );
  }

  getFlightlogStart(startId: number, countryId: number) {
    this.flightlogStart = undefined;
    this.flightlogService.getStart(startId, countryId).subscribe(
      data => {
        this.flightlogStart = data;
        console.log(this.flightlogStart);

      },
      error => {
        console.error('Error fetching flightlog Start:', error);
      },
      () => {
        console.log('Flightlog Start fetch complete');
      }
    );
  }

  openModal(template) {
    this.modalRef = this.modalService.open(template, { size: 'lg' });
  }

  closeModal() {
    this.update(true);
    this.modalRef.close();
  }
}
